import { Component, signal, output, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { toSignal } from '@angular/core/rxjs-interop';
import { Icon } from '@millionshow/client-libs';
import { SettingService } from '@millionshow/api-client';
import { NAV_ITEMS } from '../../const/nav-items.const';

@Component({
  selector: 'app-header',
  standalone: true,
  imports: [CommonModule, RouterLink, Icon],
  templateUrl: './header.component.html',
})
export default class HeaderComponent {
  private readonly settingService = inject(SettingService);

  menuToggle = output<void>();
  navItems = NAV_ITEMS;
  isDropdownOpen = signal(false);

  logoData = toSignal(
    this.settingService.settingControllerFindByKey({
      key: 'goodspace_logo_url',
    })
  );

  relatedSites = [
    { label: '밀리언쇼', url: 'https://millionshow.kr/' },
    { label: '건축박람회', url: 'https://www.allhouse.or.kr/' },
    { label: '명절선물박람회', url: 'http://www.giftfair.co.kr/' },
    { label: '농기자재전시회', url: 'https://www.agritex.kr/' },
    { label: '창업박람회', url: 'https://www.startfair.net/' },
  ];

  onMenuClick(): void {
    this.menuToggle.emit();
  }

  openDropdown(): void {
    this.isDropdownOpen.set(true);
  }

  toggleDropdown(): void {
    this.isDropdownOpen.update(v => !v);
  }

  closeDropdown(): void {
    this.isDropdownOpen.set(false);
  }
}
